import { useNavigate } from 'react-router-dom';
import { ArrowLeft, KeyRound, FolderOpen, Share2, Upload, CheckCircle2, Wifi, Radar } from 'lucide-react';

export default function HelpPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="fs-help-page">
      <button className="fs-btn fs-btn-ghost" onClick={() => navigate('/flightsync')} style={{ marginBottom: 12, width: 'auto', padding: '8px 14px', fontSize: 12 }}>
        <ArrowLeft size={14} /> VOLTAR
      </button>

      <div className="fs-hero">
        <div className="fs-hero-label">GUIA DO PILOTO</div>
        <div className="fs-hero-value">Como Sincronizar</div>
        <div className="fs-hero-sub">3 formas de enviar seus voos ao painel gestaoderpas.com.br</div>
      </div>

      <Step icon={KeyRound} num={1} title="Token do projeto">
        O administrador gera um token no painel (<em>Dados de Voo → Tokens</em>) e envia para voce por WhatsApp/email.
        Cole na tela inicial e valide. So precisa fazer isso uma vez por dispositivo.
      </Step>

      <Step icon={Radar} num={2} title="Modo automatico - MELHOR (recomendado)" highlight>
        <strong>Funciona em DJI RC, RC 2, RC Pro, RC Plus, Smart Controller Enterprise e tablets Android.</strong>
        <ol style={{ margin: '8px 0 0 18px', padding: 0, fontSize: 12 }}>
          <li>Abra <strong>Ajustes</strong> no FlightSync</li>
          <li>Toque em <strong>ESCOLHER PASTA DO DJI</strong></li>
          <li>Navegue ate a pasta do seu app:
            <ul style={{ margin: '4px 0', paddingLeft: 16 }}>
              <li>DJI Fly: <code>/sdcard/DJI/DJI Fly/</code></li>
              <li>DJI Pilot 2: <code>/sdcard/DJI/dji.pilot2/</code></li>
              <li>DJI Pilot: <code>/sdcard/DJI/dji.pilot/</code></li>
            </ul>
          </li>
          <li>Permita o acesso quando o sistema perguntar</li>
          <li>Pronto! Voos novos aparecem em ate 30s apos cada pouso</li>
        </ol>
      </Step>

      <Step icon={Share2} num={3} title="Modo compartilhar (iPhone/iPad tambem)">
        <strong>Funciona em TODOS os dispositivos.</strong>
        <ol style={{ margin: '8px 0 0 18px', padding: 0, fontSize: 12 }}>
          <li>No <strong>DJI Fly/Pilot</strong>, abra o registro do voo</li>
          <li>Toque em <strong>Compartilhar</strong></li>
          <li>Escolha <strong>FlightSync</strong> na lista</li>
          <li>O voo e importado e enviado automaticamente</li>
        </ol>
      </Step>

      <Step icon={Upload} num={4} title="Modo manual (sempre funciona)">
        Ainda da para importar arquivos manualmente: toque em <strong>Importar</strong> e selecione o .csv/.txt/.dat exportado do DJI Fly/Pilot.
      </Step>

      <Step icon={Wifi} num={5} title="Offline em campo">
        Sem internet? O FlightSync armazena os voos localmente. Assim que a conexao voltar (WiFi ou 4G), tudo e enviado automaticamente e voce recebe uma notificacao.
      </Step>

      <Step icon={CheckCircle2} num={6} title="O que o admin ve">
        Voos aparecem ao vivo em <code>gestaoderpas.com.br/flight-data</code> com indicador LIVE verde. Toda segunda 08:00 sai o relatorio semanal com top pilotos, km voados, eventos de bateria baixa, etc.
      </Step>

      <div className="fs-card" style={{ background: 'rgba(0,212,255,0.05)', borderColor: 'rgba(0,212,255,0.25)' }}>
        <div className="fs-card-title">DUVIDAS?</div>
        <p style={{ fontSize: 12, color: 'var(--fs-text-dim)', margin: 0, lineHeight: 1.6 }}>
          Fale com o admin do projeto ou acesse <code>gestaoderpas.com.br/flight-data</code>.
        </p>
      </div>
    </div>
  );
}

function Step({ icon: Icon, num, title, children, highlight }) {
  return (
    <div
      className="fs-card"
      style={highlight ? { borderColor: 'var(--fs-border-glow)', background: 'rgba(0,212,255,0.04)' } : undefined}
    >
      <div className="fs-card-title">
        <span style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 18, height: 18, borderRadius: '50%',
          background: highlight ? 'var(--fs-cyan)' : 'rgba(0,212,255,0.25)',
          color: highlight ? '#03131a' : 'var(--fs-cyan)',
          fontSize: 10, fontWeight: 700, marginRight: 4,
        }}>{num}</span>
        <Icon size={12} />
        {' '}{title}
      </div>
      <div style={{ fontSize: 13, color: 'var(--fs-text)', lineHeight: 1.6 }}>
        {children}
      </div>
    </div>
  );
}
